export default "__VITE_ASSET__DcfhUXPH__"